import {ComponentData, Entity} from "../../engine/tools/EntityManager";

export class Crank implements ComponentData {

    knob: Entity
    spindle: Entity
    handleBg: Entity
    handleFg: Entity
    lastAngle: number = 0
    locked: boolean
    rotationOffset: number = 0

    constructor(options?: Partial<Crank>) {
        Object.assign(this, options)
    }
}